export default __webpack_public_path__ + "ad962400f782e43ba734426fb52f74e0.jpeg";